import { Thumbnail } from '../../ItemCommons';
import { ThumbnailWrapper } from './CardThumbnail.styles';

interface CardThumbnailProps {
  isTileView: boolean;
  productName: string;
  productImageUrl: string;
}

export const CardThumbnail = ({
  isTileView,
  productName,
  productImageUrl,
}: CardThumbnailProps): JSX.Element => {
  if (isTileView) {
    return (
      <Thumbnail
        isRounded={false}
        alt={`Image of ${productName}`}
        width="100%"
        height={270}
        src={productImageUrl}
      />
    );
  }

  return (
    productImageUrl && (
      <ThumbnailWrapper data-testid="thumbnail-wrapper" isTileView={isTileView}>
        <Thumbnail
          isRounded
          alt={`Image of ${productName}`}
          width={60}
          height={60}
          src={productImageUrl}
        />
      </ThumbnailWrapper>
    )
  );
};
